var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-view"},[(_vm.preloader)?_c('app-overlay-loader'):_c('FullCalendar',{attrs:{"options":_vm.calendarOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }